import React from "react";
import { getAuthLogo, getAuthUserType } from "utills/authType";

export const AuthLayout = ({ children }: React.PropsWithChildren) => {
  const logo = getAuthLogo(getAuthUserType());

  return (
    <div className="w-100 min-h-screen lg:h-screen flex items-center justify-center bg-auth-background p-4 sm:p-6 lg:p-8">
      <div className="flex-1 max-w-lg bg-white rounded-2xl py-6 shadow-md">
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className={logo.className}
              src={logo.src}
              alt={logo.alt}
            />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
